/**
 * PO approval permission gate (S3.2, resolver-wired in S1.3).
 *
 * Whether the signed-in user may decide the >NT$200k release. The check is the
 * pure Axis-A rbac read (`can`) over the stored profile snapshot — the SAME
 * thin reader the MSW handlers and the route guard consume, so this gate can
 * never drift from the resolver (shared-selector parity, S0.4).
 *
 * MANAGER is no longer a magic role (plan §Slice 1.3): the old
 * `Role.ADMIN || Role.MANAGER || permissions.includes(...)` triple collapsed to
 * the explicit `purchase_orders.manage` grant. Behaviour-preserving by the
 * no-lockout seed (S0.5): every principal that could decide today HOLDS the
 * grant — role-admin via `[...ALL_PERMISSIONS]` (superadmin is a role, not a
 * code bypass), Procurement Manager directly, Branch Manager by inheritance —
 * frozen by `src/lib/rbac/__tests__/noLockoutParity.test.ts`.
 */

import { getUserProfile } from '@/services/api/axios.config';
import { can } from '@/lib/rbac';
import { Permission } from '@/models/user';
import type { User } from '@/models/user';

export function canDecidePoApproval(): boolean {
  // `can` is null-safe (no profile / no `permissions` ⇒ simply no grant) — the
  // same centralized NPE fix the route guard reads (plan top invariant).
  return can(getUserProfile() as User | null, Permission.MANAGE_PURCHASE_ORDERS);
}
